import React from 'react';
import { encryptDataset, createDatasetNFT, pushSecret } from './iexec';
import toast from 'react-hot-toast';
import { uploadFailed, loadingNotif, uploadSuccessful } from './Notifications';
import {Link} from 'react-router-dom';

class CreateNFT extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            filename: "",
            uploadStatus: false,
            NFTStatus: false,
            secretStatus: false,
            isSuccessful: false,
            fileTitle: "",
            NFTButton: <></>,
            createMore: <></>,
            submitted: false
        }
        this.displayStatus = this.displayStatus.bind(this);
        this.onSubmitTask = this.onSubmitTask.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
        this.upload = this.upload.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
        this.NFTAddress = "";
    }

    onFileChange = event => {
        this.setState({selectedFile: event.target.files[0], filename: event.target.files[0].name});
        event.preventDefault();
    }

    onTitleChange = event => {
        this.setState({fileTitle: event.target.value});
        event.preventDefault();
    }

    async displayStatus(input) {
       this.setState(input);
    }

    refreshPage() {
        window.location.reload(false)
    }

    async upload(iexec, file) {
        const loading = loadingNotif('Creating NFT...'); //Start loading notification
        try {
            const res = await encryptDataset(iexec, file, this.state.fileTitle)(); //res[0]: filename, res[1]: multiaddress, res[2]: checksum, res[3]: Encryption Key

            if(res) {
                await this.displayStatus({uploadStatus: true})
            }
            this.NFTAddress = await createDatasetNFT(iexec, this.state.fileTitle, res[1], res[2])();
            
            if(this.NFTAddress) {
                await this.displayStatus({NFTStatus: true})
            }
            const push = await pushSecret(iexec, this.NFTAddress, res[3])(); 
            toast.dismiss(loading); //Remove loading notification
            if(push) {
                this.displayStatus({secretStatus: true})
            }

        }
        catch(error) {
            this.refreshPage();
            this.setState({selectedFile: null, filename: "", uploadStatus: false, NFTStatus: false, secretStatus: false, fileTitle: ""}); //Reset state
        }
    }

    async onSubmitTask (event) {
        event.preventDefault();
        try {
            if(!this.state.selectedFile) {
                uploadFailed('Please select a file');
                return;
            }
            if(this.state.fileTitle == "" || this.state.fileTitle == null) {
                uploadFailed('Please select a name');
                return;
            }
            this.setState({ submitted: true});
            await this.upload(this.props.iexec, this.state.selectedFile);
            this.setState({selectedFile: null, filename: "", fileTitle: ""}); //Reset state
            this.setState({NFTButton: <Link to={`/manage-nft/${this.NFTAddress.toLowerCase()}`}><button className='bg-yellow font-semibold text-neutral-900 rounded-md px-4 py-3 hover:bg-secondary-200 transition duration-500'>Continue</button></Link>});
            this.setState({createMore: <button className='bg-neutral-700 font-semibold hover:text-neutral-900 rounded-md px-4 py-3 hover:bg-secondary-200 transition duration-500' onClick={this.refreshPage}>Create Another NFT</button>});
            uploadSuccessful('NFT successfully created.'); //Notify the user the upload was successful 
            this.setState({isSuccessful: true}); 
            return;

        }
        catch(error) {
            this.refreshPage();
            return;
        }
        
    }

    render() {
        return(
            <div className="p-4 font-semibold flex flex-1 items-center justify-center text-primary-50 overflow-y-auto text-center">
                <div class="cont_rond_head">
                    <div class="r_1"></div>
                    <div class="r_2"></div>
                    <div class="r_3"></div>
                </div>
                <div className="p-6 flex flex-col gap-3 bg-overlay1 p-3 md:w-1/2 text-md rounded-md">
                    <h1 className="text-xl border-b border-b-form text-left font-semibold">Upload an NFT</h1>
                    <p className='text-md leading-relaxed bg-form text-neutral-300 p-3 rounded-md justify-center items-center align-middle text-left'>
                            Easily upload any file as an <strong>NFT</strong>. Your file will get encrypted and pushed to IPFS,
                            while the encryption key gets pushed to the iExec SMS (Secret Management Service). Only you, the NFT owner, 
                            is in control of the price of the NFT, the volume, and which Dapps have permission to use the NFT.
                    </p>
                    {!this.state.submitted && <form className="">
                        <div className="w-full mb-6">
                            <label className="block text-neutral-200 text-md text-left font-bold mb-2" htmlFor="price">NFT: </label>
                            <input class="block w-full text-sm text-neutral-400 rounded border border-neutral-500 cursor-pointer focus:border-white focus:outline-none" id="file_input" type="file" onChange={this.onFileChange} required/>
                        </div>
                        <div className="w-full mb-6">
                            <label className="block text-neutral-200 text-md text-left font-bold mb-2" htmlFor="price">Name:</label>
                            <input className="appearance-none block w-full bg-form text-neutral-400 border border-neutral-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-white" id="title" type="title" onChange={this.onTitleChange} required></input>                        
                        </div>
                        <button className="bg-yellow font-semibold text-neutral-900 rounded-md w-full px-4 py-3 hover:bg-secondary-200 transition duration-500" onClick={async(event) => this.onSubmitTask(event)}>Upload NFT</button>

                    </form>}
                    <div className="status">
                        <ul className="flex flex-col">
                        {this.state.uploadStatus && <li><p className="flex align-center"><span className="material-symbols-outlined color-yellow">done</span>Encrypted File Uploaded</p></li>}
                        {this.state.NFTStatus && <li><p className="flex align-center"><span className="material-symbols-outlined">done</span>NFT successfully deployed</p></li>}
                        {this.state.secretStatus && <li><p className="flex align-center"><span className="material-symbols-outlined">done</span>Secret succesfully pushed to the SMS</p></li>}
                        </ul>
                    </div>
                    {this.state.isSuccessful && this.state.createMore && this.state.NFTButton && <div className="flex gap-3 align-center justify-center w-full">
                        {this.state.createMore}
                        {this.state.NFTButton}
                    </div>}
                </div>
            </div>
        );

    }
}

export default CreateNFT;